var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDrawerClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 0.5H27C28.3807 0.5 29.5 1.61929 29.5 3V27C29.5 28.3807 28.3807 29.5 27 29.5H3C1.61929 29.5 0.5 28.3807 0.5 27V3L0.512695 2.74414C0.640824 1.48361 1.70566 0.5 3 0.5Z",
    stroke: "#ECF0F2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5980_24531)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.6648 20.6633L9.33405 9.33261M20.6564 9.3415L9.34271 20.6552",
    stroke: "#103046",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5980_24531"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "matrix(0 -1 1 0 6 24)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrawerClose);
export default __webpack_public_path__ + "static/media/drawer-close.7e0af26f514ed11115f11caa0de3ad5c.svg";
export { ForwardRef as ReactComponent };